import { HoneypotProps } from "../../hooks/useSpamGuard";

// Positioned off-screen rather than `display: none` — the latter is trivial for a
// scraper to detect and skip. Hidden from assistive tech and the tab order so it
// is only ever reachable by something filling fields programmatically.
const HoneypotField = ({ name, value, onChange }: HoneypotProps) => (
  <div
    aria-hidden="true"
    style={{
      position: "absolute",
      width: "1px",
      height: "1px",
      overflow: "hidden",
      clip: "rect(0 0 0 0)",
      whiteSpace: "nowrap",
    }}
  >
    <label htmlFor={name}>Do not fill this in</label>
    <input
      type="text"
      id={name}
      name={name}
      value={value}
      onChange={onChange}
      tabIndex={-1}
      autoComplete="off"
    />
  </div>
);

export default HoneypotField;
